/*
  Отбор на вкладке «Подсудность домов»: адрес, участок, населённый пункт (решение
  владельца 02.11.2026 - вариант А с отборами). Вкладки-состояния стоят отдельно, под
  отбором, в `CourtHousesTab`.

  Перечни участков и пунктов приходят с сервера и собраны по ВСЕМУ портфелю, а не по
  странице: иначе в списке не нашлось бы участка, дома которого на другой странице.
  Поиск уходит на сервер по Enter и при уходе из поля, а не на каждую букву - каждый
  запрос разбирает адреса всего портфеля. На телефоне отбор свёрнут под кнопкой, как в
  реестре (`RegistryFilters`).
*/

import { useEffect, useRef, useState } from 'react'

import { Field, Select } from './Common.jsx'

export const NO_COURT = 'none'

export default function CourtHouseFilters({ filter, courts, settlements, onChange }) {
  const [open, setOpen] = useState(false)
  const applied = [filter.q, filter.court, filter.settlement].filter(Boolean).length

  const courtOptions = Object.fromEntries([
    ...courts.map((court) => [court.id, court.label]),
    [NO_COURT, 'участок не определён'],
  ])
  const settlementOptions = Object.fromEntries(settlements.map((name) => [name, name]))

  return (
    <>
      <button
        type="button"
        className="filters-toggle button button--quiet"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        {open ? 'Скрыть отбор' : 'Отбор'}
        {applied ? ` · ${applied}` : ''}
      </button>
      <div className={`filters${open ? ' filters--open' : ''}`}>
        <SearchField value={filter.q} onApply={(q) => onChange({ ...filter, q })} />
        <Field label="Участок">
          <Select
            value={filter.court}
            onChange={(court) => onChange({ ...filter, court })}
            options={courtOptions}
            empty="все участки"
          />
        </Field>
        <Field label="Населённый пункт">
          <Select
            value={filter.settlement}
            onChange={(settlement) => onChange({ ...filter, settlement })}
            options={settlementOptions}
          />
        </Field>
        {applied ? (
          <button
            className="button button--quiet"
            type="button"
            onClick={() => onChange({ ...filter, q: '', court: '', settlement: '' })}
          >
            Сбросить отборы
          </button>
        ) : null}
      </div>
    </>
  )
}

function SearchField({ value, onApply }) {
  const input = useRef(null)
  // «Сбросить отборы» меняет значение не отсюда - текст поля подтягивается к нему.
  useEffect(() => {
    if (input.current && input.current.value !== value) input.current.value = value
  }, [value])
  const apply = (text) => {
    const next = text.trim()
    if (next !== value) onApply(next)
  }
  return (
    // Подсказка в поле короткая (02.11.2026, замечание владельца: длинная обрезалась
    // на «или»), а что искать - под значком «i».
    <Field
      label="Найти дом"
      width="l"
      hint="Часть адреса: улица, номер дома или посёлок. Ищет по записи выгрузки и по полному адресу дома."
    >
      <input
        ref={input}
        className="field__input"
        type="search"
        placeholder="улица или дом"
        defaultValue={value}
        onBlur={(event) => apply(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') apply(event.target.value)
        }}
      />
    </Field>
  )
}
